import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function StorySection() {
  return <section className="py-20 px-4 bg-[#0f0f18] relative" data-id="element-158">
      <div className="max-w-3xl mx-auto" data-id="element-159">
        {/* Opening Hook */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="mb-16" data-id="element-160">
          <div className="border-l-4 border-[#f5a623] pl-6 py-2 mb-8" data-id="element-161">
            <p className="text-xl md:text-2xl font-playfair italic text-[#e0e0e0] leading-relaxed" data-id="element-162">
              "Son las 9 de la noche. Has comido 'bien' todo el día, pero de
              repente aparece esa pulsación en la base del cráneo. No es hambre
              real. Es una necesidad desesperada de algo dulce que no te deja
              descansar."
            </p>
          </div>
          <p className="text-lg text-[#a0a0b0] leading-relaxed font-inter" data-id="element-163">
            Te encuentras frente a la despensa, buscando ese chocolate
            escondido, y lo terminas comiendo con culpa, sintiendo que no tienes
            disciplina. Pero el problema no es tu carácter.{' '}
            <span className="text-[#00d4ff] font-semibold" data-id="element-164">
              Es tu bioquímica.
            </span>
          </p>
        </motion.div>

        {/* The Problem */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="mb-20" data-id="element-165">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold mb-6 text-white" data-id="element-166">
            El secuestro silencioso de tu metabolismo
          </h2>
          <div className="space-y-6 text-lg text-[#a0a0b0] leading-relaxed font-inter" data-id="element-167">
            <p data-id="element-168">
              El azúcar procesado ha secuestrado tus niveles de dopamina y ha
              vuelto "sordas" a tus células ante la insulina. No puedes dejar de
              comer dulce porque tu cerebro está gritando por energía que no
              sabe procesar.
            </p>
            <p data-id="element-169">
              Intentas resistir, pero la fatiga de la tarde te vence. Te
              despiertas con la{' '}
              <span className="text-[#ff6b6b] font-medium" data-id="element-170">cara hinchada</span>,
              el{' '}
              <span className="text-[#ff6b6b] font-medium" data-id="element-171">
                abdomen inflamado
              </span>{' '}
              y una{' '}
              <span className="text-[#ff6b6b] font-medium" data-id="element-172">neblina mental</span>{' '}
              que ni el tercer café del día logra despejar. Estás atrapada en un
              ciclo de picos de azúcar y caídas de energía que te agotan
              físicamente.
            </p>
          </div>
        </motion.div>

        {/* Why What You Tried Didn't Work */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="bg-[#161622] border border-[#ff6b6b]/20 rounded-2xl p-8 md:p-10 shadow-[0_0_30px_rgba(255,107,107,0.05)]" data-id="element-173">
          <h3 className="text-2xl font-playfair font-bold mb-8 text-white text-center" data-id="element-174">
            Por qué lo que has intentado no funciona
          </h3>
          <ul className="space-y-6" data-id="element-175">
            {['Las dietas restrictivas fallan porque no desactivan la señal de hambre de dopamina en tu cerebro.', 'Sustituir con edulcorantes artificiales engaña a tu lengua, pero confunde a tu metabolismo y empeora el antojo horas después.', 'Confiar en la "fuerza de voluntad" es imposible cuando tus hormonas están enviando señales de emergencia a tu sistema nervioso.'].map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-176">
                <XCircleIcon className="w-6 h-6 text-[#ff6b6b] shrink-0 mt-1" data-id="element-177" />
                <span className="text-[#e0e0e0] text-lg font-inter leading-relaxed" data-id="element-178">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}